import(/* webpackMode: "eager" */ "/vercel/path0/src/app/privacy-policy/page.tsx");
